/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import OnboardingWizardInnerPermissionsQuery, {
	type OnboardingWizardInnerPermissionsQuery as OnboardingWizardInnerPermissionsQueryType,
} from '@jira/admin-pages__onboarding-hub-wizard/src/__generated__/OnboardingWizardInnerPermissionsQuery.graphql';

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type OnboardingHubWizardWithDelegatedAdminEntryPointComponent = EntryPointComponent<
	{
		PermissionsQuery: OnboardingWizardInnerPermissionsQueryType;
	},
	{},
	{},
	{
		id: string;
	}
>;

export const onboardingHubWizardWithDelegatedAdminEntryPoint: EntryPoint<
	OnboardingHubWizardWithDelegatedAdminEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	// Using `JSResourceForInteraction` to avoid SSR
	root: JSResourceForInteraction<OnboardingHubWizardWithDelegatedAdminEntryPointComponent>(
		/* webpackChunkName: "async-onboarding-hub-wizard-with-delegated-admin" */ './OnboardingHubWizardWithDelegatedAdminEntryPointRoot.tsx',
	),
	getPreloadProps: ({
		context,
		tenantContext: { cloudId, isAdmin, appEditions },
	}: EntryPointRouteParams) => ({
		extraProps: {
			id: context.match.params?.id || '',
		},
		queries: {
			PermissionsQuery: {
				options: { fetchPolicy: 'store-and-network' as const },
				parameters: OnboardingWizardInnerPermissionsQuery,
				variables: {
					cloudId,
					// We can skip the permission check when:
					// 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
					// 2. Upsell is enabled (because upsell is only available to admins)
					skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION',
				},
			},
		},
	}),
});
